import { Module } from 'vuex';
import { State as RootState } from '@/store/state';

// 事件跟踪模块

export interface EventItem {
  eventName: string;
  eventLabel: string | undefined;
}

export interface EventTrackingState {
  lastEvent: EventItem | null;
}

export const eventTracking: Module<EventTrackingState, RootState> = {
  namespaced: true,
  state: {
    lastEvent: null
  },
  mutations: {
    // 保存最后一个事件
    addEvent(state, payload: EventItem) {
      state.lastEvent = payload;
    },
  },
  getters: {
    // 获取最后一个事件
    getLastEvent: (state) => {
      return state.lastEvent;
    },
    
    // 获取最后一个事件名称
    getLastEventName: (state) => {
      return state.lastEvent ? state.lastEvent.eventName : 'Unknown';
    },
    
    // 获取最后一个事件的标签
    getLastEventLabel: (state) => {
      return state.lastEvent ? state.lastEvent.eventLabel : 'Unknown';
    }
  }
};
